/* eslint-disable no-dupe-else-if */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { getThirdAppAuthorizeUrl } from '@/apis/login/login.api';
import TipIconSvg from '@/assets/icons/TipIcon.svg';
import LoginType from '@/intl-jdi-common-ssr/constants/loginConfig';
import { useTranslation } from '@/i18n/client';
import { maskEmail, maskPhone } from '@/utils/helpers';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import Box from '@mui/material/Box';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import style from '../../index.module.scss';
import { bindLoginTypes, userDetailRes } from '../../types';
import DeleteAccount from '../deleteAccount/deleteAccount';
// 埋点
import { EXPOSURE_RECORD, sendClickTrack } from '@/tracks/31803';
import { PROFILE_EVENT_NAMES, profileBusinessLogger } from '@/utils/logger/instance/profileLogger';
const BoxSX = {
  width: '100%',
  height: '60px',
  borderRadius: 1,
  bgcolor: '#F7F8FC',
  marginBottom: '10px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  cursor: 'pointer',
};
const BtnSX = {
  fontSize: 16,
  color: '#888B94',
  margin: '0 10px',
};
interface ProsType {
  jumpToDialog: (props: { type: string; flag?: string }) => void; // 跳转到邮箱认证页面
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  userInfo: userDetailRes | null; // 用户信息
}
const ContentList = ({ jumpToDialog, userInfo }: ProsType) => {
  const { t } = useTranslation();
  const [email, setEmail] = useState<string | null>('Add'); // 邮箱
  const [emailState, setEmailState] = useState<string | null>('Add'); // 邮箱
  const [phone, setPhone] = useState<string | number | null>(''); // 手机 Add
  const [phoneState, setPhoneState] = useState<string>(''); // 手机的添加修改状态
  const [emailFlag, setEmailFlag] = useState<boolean>(false);
  const [addOrEdit, setAddOrEdit] = useState<string>('');
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const [linkAccount, setLinkAccount] = useState<string | null>(''); // 账号关联
  const [linkState, setLinkState] = useState<string | null>('Add');
  const [linkThirdUrl, setLinkThirdUrl] = useState<string>(''); // 关联三方账号地址
  const origin = (window as any).location.origin;

  useEffect(() => {
    if (userInfo) {
      if (!userInfo.email) {
        setEmail(t('settings.add'));
        setEmailState('Add');
      } else if (userInfo.emailVerified == 0 && userInfo.email) {
        setEmail('Unverified');
        setEmailState('Unverified');
      } else if (userInfo.emailVerified == 1 && userInfo.email) {
        setEmail(maskEmail(userInfo.email));
        setEmailState('Change');
      }
      if (userInfo.mobile) {
        setPhone(maskPhone(String(userInfo.mobile)));
        setPhoneState('Change');
      } else {
        setPhone(t('settings.add'));
        setPhoneState('Add');
      }

      if (userInfo.bindOchama) {
        setLinkAccount(t('profile.page.link'));
        setLinkState('Add');
      } else {
        setLinkAccount(t('profile.page.bounded'));
        setLinkState('Change');
      }
      /*
      loginType : 1 2 3 4
      1: 设置过密码
      2: 手机号登录
      3: 邮箱登录
      4: 第三方登录

      1: 手机号登录 - 邮箱未认证->没有密码;  显示: no password;
      2: 手机号登录 - 邮箱已认证->没有密码;  显示: add password;
      3: 邮箱登录 - change password;
      4: 第三方登录 - 邮箱未认证->没有密码;  显示: no password;
      5: 第三方登录 - 邮箱已认证->没有密码;  显示: add password;
      6: 第三方登录 - 邮箱已认证->有密码;  显示: change password;
      7: 手机号登录 - 邮箱已认证->有密码;  显示: change password;
      
      */

      if (userInfo.bindLoginTypes && userInfo.bindLoginTypes?.length > 0) {
        const bindLogin: bindLoginTypes[] = userInfo?.bindLoginTypes;

        let hasLoginType1 = false;
        let hasLoginType3 = false;

        bindLogin.forEach((item: any) => {
          if (item.status === 1) {
            if (item.loginType === 1) {
              hasLoginType1 = true;
            } else if (item.loginType === 3) {
              hasLoginType3 = true;
            }
          }
        });

        if (hasLoginType1) {
          // 当前账号有密码
          setEmailFlag(true);
          setAddOrEdit('changePassword');
        } else if (!hasLoginType3) {
          // 当前账号没有认证邮箱
          setEmailFlag(false);
          setAddOrEdit('noPassword');
        } else if (hasLoginType3 && !hasLoginType1) {
          // 当前账号认证邮箱 没有密码
          setEmailFlag(true);
          setAddOrEdit('addPassword');
        }
      }
    }
    getLinkUrl();
  }, [userInfo]);
  interface JumpProps {
    type: string;
    flag?: string;
  }

  // 获取关联账号的页面链接
  const getLinkUrl = async () => {
    const [err, res]: any = await getThirdAppAuthorizeUrl({
      loginType: LoginType.LoginTypeEnum.OCHAMA,
      redirectUrl: `${origin}/profile`,
    });
    if (res && res.code === '200') {
      setLinkThirdUrl(res.data?.authorizeUri);
    }
  };

  const emailJumpToDialog = () => {
    let data: JumpProps = { type: '', flag: '' };
    emailState == 'Unverified' ? (data = { type: 'UnverifiedEmail', flag: 'Unverified' }) : null;
    emailState == 'Add' ? (data = { type: 'AddEmail', flag: 'Add' }) : null;
    emailState == 'Change' ? (data = { type: 'ChangeEmail', flag: 'Add' }) : null;
    jumpToDialog(data);
  };

  const phoneJumpToDialog = () => {
    let data: JumpProps = { type: '', flag: '' };
    phoneState == 'Add' ? (data = { type: 'addPhone', flag: 'Add' }) : null;
    phoneState == 'Change' ? (data = { type: 'changePhone', flag: 'Change' }) : null;
    jumpToDialog(data);
  };
  const accountJumpToDialog = () => {
    setOpenDialog(true);
  };

  const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.black,
    },
  }));

  // 点击跳转ochama
  const linkJumpToOchama = () => {
    if (linkState === 'Add' && linkThirdUrl) {
      window.location.href = linkThirdUrl;
      sendClickTrack.Account_Link_ochama_Click({
        btnShowType: '1',
      });
    } else {
      sendClickTrack.Account_Link_ochama_Click({
        btnShowType: '3',
      });
    }
    try {
      profileBusinessLogger({
        eventName: PROFILE_EVENT_NAMES.LINK_OCHAMA_ACCOUNT,
        message: {
          linkState: linkState || '',
          linkThirdUrl,
          userInfo: JSON.stringify(userInfo),
        },
      });
    } catch (err) {}
  };

  const linkedTrack = () => {
    sendClickTrack.Account_Link_ochama_Click({
      btnShowType: '2',
    });
  };

  return (
    <div className={style.content__list}>
      <Box sx={BoxSX}>
        <div className={`${style.content__list__title} ${style.content__flex}`}>
          {t('profile.page.linkBtn')}
          <BootstrapTooltip
            title={
              <>
                <div className={style.instructions__title}>
                  {t('profile.page.linkInstructionsTitle')}
                </div>
                <div className={style.instructions__content}>
                  {t('profile.page.linkInstructions')}
                </div>
              </>
            }
            placement='top'
          >
            <div>
              <TipIconSvg style={{ marginLeft: 8 }} />
            </div>
          </BootstrapTooltip>
        </div>
        <div className={style.content__list__footer}>
          {linkState === 'Add' ? (
            <>
              <span
                className={`${style.footer__text} ${style.link__text__add}`}
                exptag={'exp|' + EXPOSURE_RECORD.Account_Linkochama_Exp}
                data-exptag-config={JSON.stringify({
                  useClick: false,
                  stay_duration: 0.3,
                  repeated: false,
                  area_rate: 0.5,
                })}
                onClick={linkJumpToOchama}
              >
                {linkAccount}
              </span>
              <ArrowForwardIosIcon sx={BtnSX} />
            </>
          ) : (
            <span
              className={`${style.footer__text} ${style.link__text__bind}`}
              onClick={linkedTrack}
            >
              {linkAccount}
            </span>
          )}
        </div>
      </Box>
      <Box sx={BoxSX} onClick={emailJumpToDialog}>
        <div className={style.content__list__title}>{t('settings.email')}</div>
        <div className={style.content__list__footer}>
          <span
            className={
              (style.footer__text,
              emailState == 'Add' ? style.footer__text__add : '',
              emailState == 'Unverified' ? style.email_text_unverified : '',
              emailState == 'Change' ? style.email_text_black : '')
            }
            onClick={emailJumpToDialog}
          >
            {emailState == 'Unverified' ? (
              <span
                className={style.email_Unverified}
                style={{ display: 'flex', alignItems: 'center', fontSize: '16px' }}
              >
                <span style={{ color: '#1a1a1a' }}>{userInfo?.email}</span>
                <span style={{ marginLeft: '10px', color: '#FF4D4F' }}>
                  {t('settings.emailInfo.verifyNow')}
                </span>
              </span>
            ) : (
              email
            )}
          </span>
          <ArrowForwardIosIcon sx={BtnSX} />
        </div>
      </Box>
      <Box sx={BoxSX} onClick={phoneJumpToDialog}>
        <div className={style.content__list__title}>{t('settings.phoneNumber')}</div>
        <div className={style.content__list__footer}>
          <span
            className={
              (style.footer__text,
              phoneState == 'Add' ? style.footer__text__add : undefined,
              phoneState == 'Change' ? style.footer__text__black : undefined)
            }
          >
            {phone}
          </span>
          <ArrowForwardIosIcon sx={BtnSX} />
        </div>
      </Box>
      {emailFlag && (
        <Box sx={BoxSX} onClick={() => jumpToDialog({ type: addOrEdit })}>
          <div className={style.content__list__title}>
            {addOrEdit == 'addPassword' ? t('settings.addPassword') : t('settings.changePassword')}
          </div>
          <div className={style.content__list__footer}>
            <span
              className={
                (style.footer__text,
                addOrEdit == 'addPassword' ? style.footer__text__add : undefined)
              }
            >
              {addOrEdit == 'addPassword' ? t('settings.add') : ''}
            </span>
            <ArrowForwardIosIcon sx={BtnSX} />
          </div>
        </Box>
      )}
      <Box sx={BoxSX} onClick={accountJumpToDialog}>
        <div className={style.content__list__title}>{t('settings.deleteAccount')}</div>
        <div className={style.content__list__footer}>
          <ArrowForwardIosIcon sx={BtnSX} />
        </div>
      </Box>
      <DeleteAccount
        open={openDialog}
        userInfo={userInfo}
        closeFn={() => {
          setOpenDialog(false);
        }}
      />
    </div>
  );
};

export default ContentList;
